import * as React from "react";
import { ZRCMessage } from "src/businessServices/services/bsChat/rocketChat/rocketChat.types";
import styles from "./ReplyMsg.module.less";

interface PropsReplyMsg {
  msg: ZRCMessage;
  renderText: (text: string) => React.ReactNode;
}

export const ReplyMsg: React.FC<PropsReplyMsg> = ({
  msg: { attachments, _id, msg, u },
  renderText,
}) => {
  const attachmentsNames =
    attachments
      ?.map((a, i) => ({ ...a, key: `${_id}:${i}` }))
      .map((a) => ("title" in a ? a.title : null))
      .filter(Boolean) || [];
  return (
    <div className={styles.reply}>
      <div>{u?.username}</div>
      {msg && <span className={styles.replyContent}>{renderText(msg)}</span>}
      {!!attachmentsNames.length && (
        <span> / {attachmentsNames.join(", ")}</span>
      )}
    </div>
  );
};
